import { makeStyles } from '@material-ui/core/styles'
import KycPayment from 'src/assets/Buy_Policy_Images/kycPayment.svg'
import React, { useCallback, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { COLORS } from 'src/utils/Themes/colors'
import {
  fetchTokenForBuyPolicy,
  getPolicyDownload,
  saveISNPStatus,
} from 'src/services/buyPolicyService'
import LoadingModal from 'src/components/common/LoadingModal'
import { getTokenForQrReport } from 'src/services/individualService'
import { useDispatch, useSelector } from 'react-redux'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { showNotificationMessage } from 'src/actions'
import { getISNPStatusRequestBody } from 'src/utils/commonMethods/buyPolicy'
import {
  CURRENT_STATUS,
  ENCOUNTERED_ERROR_WHILE_SAVING,
  INSURANCE_TYPE_CATOGORIES,
} from 'src/utils/constants/BuyPolicy'
import { scrollToTop } from 'src/utils/commonMethods'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'

const KycComplete = () => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const { search } = useLocation()
  const searchParams = React.useMemo(
    () => new URLSearchParams(search),
    [search]
  )
  const enquiryId = searchParams.get('enquiryId')
  const guestUserDetails = useSelector((state) => state?.buyPolicyReducer)

  const handleBackToLogIn = () => {
    window.open(process?.env?.REACT_APP_TROVITY_LOGIN_URL, '_self')
  }

  const fetchToken = async () => {
    setLoading(true)
    const response = await getTokenForQrReport()
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)

      const token = response?.res?.data?.access_token
      await downloadPolicyDocument(token)
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    }
  }

  const downloadPolicyDocument = async (token) => {
    const response = await getPolicyDownload(token, enquiryId)

    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      } else {
        setLoading(false)
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(new Blob([response?.res?.data]))
        link.setAttribute('download', 'PolicyDocument.pdf')
        link.setAttribute('target', '_blank')
        document.body.appendChild(link)
        link.click()
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message:
            NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_POLICY_DETAILS,
        })
      )
    }
  }

  const saveISNPStatusTasks = useCallback(
    async (token) => {
      setLoading(true)
      const formData = getISNPStatusRequestBody(
        guestUserDetails,
        INSURANCE_TYPE_CATOGORIES?.health,
        CURRENT_STATUS?.kycSuccessPaymentSuccess
      )

      saveISNPStatus(token, formData)
        .then((response) => {
          return response?.res?.data
        })
        .then(() => {
          setLoading(false)
        })
        .catch(() => {
          setLoading(false)
          dispatch(
            showNotificationMessage({
              type: NOTIFICATION_TYPES?.ERROR,
              message: ENCOUNTERED_ERROR_WHILE_SAVING,
            })
          )
        })
    },
    [dispatch, guestUserDetails]
  )

  const saveMetadataAndNavigate = useCallback(() => {
    setLoading(true)

    fetchTokenForBuyPolicy()
      .then((token) => {
        setLoading(false)
        saveISNPStatusTasks(token)
      })
      .catch(() => {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
          })
        )
      })
  }, [dispatch, saveISNPStatusTasks])

  useEffect(() => {
    scrollToTop()
    saveMetadataAndNavigate()
  }, [saveMetadataAndNavigate])

  return (
    <div>
      <LoadingModal loading={loading} />
      <div className={classes.mainContainer}>
        <div className={classes.kycContainer}>
          <div className={classes.heading}>
            <div>
              <img src={KycPayment} alt='kyc complete' />
            </div>
            <div className={classes.kycContent}>
              <span className={classes.kycHeading}>KYC Completed</span>
            </div>
          </div>
          {enquiryId && (
            <div className={classes.downloadContainer}>
              Please&nbsp;
              <span className={classes.downloadClick} onClick={fetchToken}>
                click here
              </span>
              &nbsp; to download your policy
            </div>
          )}
          <div>
            <div className={classes.input}>
              <span
                className={classes.log}
                onClick={handleBackToLogIn}
                data-testid='login-link'
              >
                Log in
              </span>
              &nbsp;
              <span className={classes.content}>
                into your Trovity account to view & download your policy
              </span>
            </div>
            <div className={classes.input}>
              <span className={classes.subContent}>
                (Registration details have been shared to your email)
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.descriptionContainer}>
        <span className={classes.description}>
          We&apos;re thrilled to have you covered
        </span>
      </div>
    </div>
  )
}

export default KycComplete
const useStyles = makeStyles({
  kycContainer: {
    background: 'linear-gradient(185.98deg, #CEF3FF -18.56%, #FFFFFF 67.98%)',
    border: 'none',
    width: '60%',
    padding: '30px 80px 30px 80px',
    boxShadow: '0px 6px 8px 0px #4DC3E333',
    borderRadius: '10px',
  },
  mainContainer: {
    padding: '80px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    background: 'white',
  },
  heading: {
    display: 'flex',
    padding: '30px',
    gap: '10%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  kycContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  kycHeading: {
    fontSize: '37px',
    color: '#4FB9D6',
  },
  log: {
    fontSize: '22px',
    color: '#3EAFCD',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  content: {
    fontSize: '20px',
    color: '#000000',
  },
  subContent: {
    fontSize: '15px',
    color: '#000000',
  },
  input: {
    textAlign: 'center',
    marginBottom: '5px',
  },
  textContainer: {
    textAlign: 'center',
  },
  text: {
    fontSize: '14px',
    color: '#9AAFB5',
  },
  descriptionContainer: {
    textAlign: 'center',
    background: 'white',
    padding: '60px',
  },
  description: {
    fontSize: '18px',
    fontStyle: 'italic',
    color: '#CCCCCC',
  },
  downloadContainer: {
    textAlign: 'center',
    marginBottom: '10px',
  },
  downloadClick: {
    color: COLORS.DARK_PINK,
    cursor: 'pointer',
  },
})
